import React from "react";
import { getAmoePolicy, getSweepsCoinName } from "../../../utility/complianceCopy";
import { useComplianceConfig } from "../../../utility/useComplianceConfig";

export default function AmoePolicyContent() {
  useComplianceConfig();
  const { mailingAddress, validityDays, creditAmount } = getAmoePolicy();

  return (
    <section className="info-default-layout" aria-label="Current mail-in entry instructions">
      <h2>Mail-in entry instructions</h2>
      <p>No purchase necessary. Request a unique code after identity verification and CAPTCHA. The code is valid for {validityDays} days from issuance. Each valid mailed entry awards {creditAmount} {getSweepsCoinName()} to your promotional balance.</p>
      <p>Handwrite your full name, verified account email, current physical address and code in legible black ink on one blank 4×6 index card. Place only that card in a standard #10 envelope. Printed, typed, photocopied or machine-reproduced entries are not eligible.</p>
      <h3>Mail your entry to</h3>
      {mailingAddress ? (
        <address style={{ whiteSpace: "pre-line" }}>{mailingAddress}</address>
      ) : (
        <p role="status">Mailing address not configured. New code requests are unavailable until the address is published.</p>
      )}
      <p>If a mailed entry arrives after its code expires, an authorized reviewer may approve it only when its postmark falls within that code’s original validity window.</p>
    </section>
  );
}
